module.exports = __webpack_public_path__ + "img/SWP_Hammer_1H_01 (1).4bd20130.png";